module.exports = __webpack_public_path__ + "static/assets/a200552d95ee97efa1f754ebf3fb5799.png";